import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-navy-mid px-5 py-12 sm:py-20" data-id="element-88" data-mp="223eltma3nb3z">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-gold/45 bg-navy p-8 text-center sm:p-12" data-id="element-89" data-mp="222wk4a4o44oo">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-gold" data-id="element-90" data-mp="1j52co0j6u18e">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-91" data-mp="1edc0rq4lr5ev" />
        </span>
        <h2 className="mt-5 font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-92" data-mp="qnzq0ltmmpag">
          14-Day Money-Back Guarantee
        </h2>
        <p className="mt-2 text-sm font-medium text-gold sm:text-base" data-id="element-93" data-mp="lo4x6cqajpmr">
          Take the time to see how it fits your classes.
        </p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-94" data-mp="oxp1i0q6f2zu">
          <p data-id="element-95" data-mp="twi2itoa11j4">
            Take a look through THE COMPLETE ART YEAR™ and see how the resources fit your classes.
            If you decide it isn&apos;t the right fit, contact us within the guarantee period and
            follow the refund terms provided with your purchase.
          </p>
          <p data-id="element-96" data-mp="62i46sivuyi1">
            The six core volumes and five professional bonuses are yours to review in full during
            that period.
          </p>
          <p className="font-semibold italic text-white" data-id="element-97" data-mp="f0u1fde98ujg">
            You decide whether the system belongs in your classroom.
          </p>
        </div>
        <div className="mt-8 w-full max-w-md" data-id="element-98" data-mp="jyc2khm165gw">
          <CTAButton label="GET THE COMPLETE ART YEAR™" data-id="element-99" data-mp="1qhacyvmour11" />
          <p className="mt-3 text-xs text-white/60 sm:text-sm" data-id="element-100" data-mp="1qiv6qj16i5xu">
            One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
          </p>
        </div>
      </motion.div>
    </section>;
}